export default __webpack_public_path__ + "static/media/top2bg.862137a9.png";